import { render, staticRenderFns } from "./AgentEdit.vue?vue&type=template&id=2356e65c&scoped=true&"
import script from "./AgentEdit.vue?vue&type=script&lang=js&"
export * from "./AgentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356e65c",
  null
  
)

export default component.exports